import apiClient from "./apiClient";


const services = [
  {
    iconName: 'FaCode',
    title: 'Web Development',
    description: 'We create responsive, secure, and fast web apps tailored to your business.',
  },
  {
    iconName: 'FaMobileAlt',
    title: 'Mobile Apps',
    description: 'Build beautiful native and cross-platform apps for iOS and Android.',
  },
  {
    iconName: 'FaCloud',
    title: 'Cloud Services',
    description: 'Leverage scalable cloud infrastructure and DevOps for high performance.',
  },
  {
    iconName: 'FaLock',
    title: 'Cybersecurity',
    description: 'Protect your applications and data with top-notch security measures.',
    },
  {
    iconName: 'FaSearch',
    title: 'SEO Optimization',
    description: 'Boost your online visibility and search engine rankings effectively.',
    },
   {
    iconName: 'FaShoppingCart',
    title: 'E-commerce Solutions',
    description: 'Build and scale secure online stores with custom shopping experiences.',
    },
   {
    iconName: 'FaBug',
    title: 'QA & Testing',
    description: 'Ensure product quality with manual and automated testing solutions.',
    },
   {
    iconName: 'FaGlobe',
    title: 'Web Hosting & Domains',
    description: 'Fast and reliable hosting with domain management and SSL support.',
  },
  {
    iconName: 'FaHandshake',
    title: 'IT Consulting',
    description: 'Get expert guidance to plan, scale, and optimize your digital strategy.',
    },
  {
    iconName: 'FaRetweet',
    title: 'Legacy System Modernization',
    description: 'Revamp old systems using modern technologies while preserving functionality.',
    },
  {
    iconName: 'FaWrench',
    title: 'Custom Feature Development',
    description: 'Add new functionalities and features to your existing system.',
    },
  {
    iconName: 'FaShieldAlt',
    title: 'Security & Compliance',
    description: 'Identify system vulnerabilities and ensure compliance with industry standards.',
  },
];


export const getServices = async () => {
  try {
    const response = await apiClient.get("/services");
    return response.data;
  } catch (error) {
      console.error("Error fetching services:", error);
      //throw error; // rethrow so component can handle it
      return services;
  }
};
